import { REDUX_VIEW_TYPES } from './action'

const initialState = {
  userMenuVisible: false,
  dragResult: false,
  statusDragged: false,
  statusDropped: false,
  listMode: 'list',
  columnType: 'date',
  userMode: 'broker',
  multiSelectMode: false,
  assignTeamMode: false,
  multiEditMode: false,
  isFiltersVisible: false,
  isToggleGroupActive: false,
  resetToDefaultSort: false
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case REDUX_VIEW_TYPES.USER_MENU_VISIBLE:
      return {
        ...state,
        isUserMenuVisible: action.payload
      }
    case REDUX_VIEW_TYPES.IS_LOADING:
      return {
        ...state,
        isLoading: action.payload
      }
    case REDUX_VIEW_TYPES.TOAST:
      return {
        ...state,
        toast: action.payload
      }
    case REDUX_VIEW_TYPES.BOARD_DRAG_RESULT:
      if (action.payload) {
        const { source, destination } = action.payload
        if (!source || !destination) {
          return { ...state }
        }

        const statusDrag = source?.droppableId?.replace(/col-/g, '')
        const statusDrop = destination?.droppableId?.replace(/col-/g, '')
        return {
          ...state,
          statusDragged: statusDrag,
          statusDropped: statusDrop,
          dragResult: action.payload
        }
      }

      return {
        ...state,
        dragResult: action.payload,
        statusDragged: false,
        statusDropped: false
      }
    case REDUX_VIEW_TYPES.STATUS_DRAGGED:
      return {
        ...state,
        statusDragged: action.payload
      }
    case REDUX_VIEW_TYPES.STATUS_DROPPED:
      return {
        ...state,
        statusDropped: action.payload
      }
    case REDUX_VIEW_TYPES.BOARD_GROUP:
      return {
        ...state,
        boardGroup: action.payload
      }
    case REDUX_VIEW_TYPES.LIST_MODE:
      return {
        ...state,
        listMode: action.payload
      }
    case REDUX_VIEW_TYPES.COLUMN_TYPE:
      return {
        ...state,
        columnType: action.payload
      }
    case REDUX_VIEW_TYPES.USER_MODE:
      return {
        ...state,
        userMode: action.payload
      }
    case REDUX_VIEW_TYPES.MULTI_SELECT_MODE:
      return {
        ...state,
        multiSelectMode: action.payload
      }
    case REDUX_VIEW_TYPES.MULTI_EDIT_MODE:
      return {
        ...state,
        multiEditMode: action.payload
      }
    case REDUX_VIEW_TYPES.ASSIGN_TEAM_MODE:
      return {
        ...state,
        assignTeamMode: action.payload
      }
    case REDUX_VIEW_TYPES.TOGGLE_FILTERS:
      return {
        ...state,
        isFiltersVisible: action.payload
      }
    case REDUX_VIEW_TYPES.TOGGLE_GROUPING:
      return {
        ...state,
        isToggleGroupActive: action.payload
      }
    case REDUX_VIEW_TYPES.DISABLE_GROUPING:
      return {
        ...state,
        isToggleGroupActive: action.payload
      }
    case REDUX_VIEW_TYPES.RESET_TO_DEFAULT_SORT:
      return {
        ...state,
        resetToDefaultSort: action.payload
      }
    default:
      return state
  }
}
